var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$route.name !== 'Packshot')?_c('abstraktion-navigation',{attrs:{"modules":_vm.modules,"module":_vm.module}}):_vm._e(),(_vm.$route.name !== 'Packshot')?_c('head-bar'):_vm._e(),_c('router-view',{key:_vm.$route.fullPath})],1)}
var staticRenderFns = []

export { render, staticRenderFns }